// @flow

import React, { type Node } from 'react';

import { SubmittingContext } from './context';

type Props = {|
  +submitting: boolean,
  +children: Node,
|};

export function SubmittingProvider({ submitting, children }: Props): Node {
  return (
    <SubmittingContext.Provider value={submitting}>
      {children}
    </SubmittingContext.Provider>
  );
}
